(() => {
  if (customElements.get('related-products')) {
    return;
  }

  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};

      this.sliderPrev = this.querySelector('.swiper-arrow--prev');
      this.sliderNext = this.querySelector('.swiper-arrow--next');
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        slidesPerView: 2,
        spaceBetween: 5,
        initialSlide: 1.5,
        autoHeight: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        navigation: {
          prevEl: this.sliderPrev,
          nextEl: this.sliderNext,
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 18,
            initialSlide: 1,
          },
        },
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);
    }
  }

  customElements.define('related-products', RelatedProducts);
})();
